module.exports = __webpack_public_path__ + "static/media/frozen-root-beer-dt-fr.42d0f52e.mp4";